export enum SuggestionsTableAccessor {
  Receipt = 'receipt',
  Amount = 'amount',
  Description = 'description',
  Account = 'account',
  Score = 'score',
  CurrentVat = 'currentVat',
  SuggestedVat = 'suggestedVat',
  Approve = 'approve',
  Rejected = 'rejected',
}
